
import { Vue, Component, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import WorkbenchesService from '@/services/workbenches.service';

@Component({})
export default class CollisionLineStore extends Vue {
  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  pagination: any = {
    pageSize: 10,
    current: 1,
    total: 0,
    onChange: this.paginationChange,

  };
  dataSource = [];
  columns = [
    {
      title: '店铺名称',
      dataIndex: 'shop_name',
      align: 'center',
    },
    {
      title: '门店POI',
      dataIndex: 'poi',
      align: 'center',
    },
    {
      title: '推广通计划ID',
      dataIndex: 'campaign_id',
      align: 'center',
    },
    {
      title: '推广通计划名称',
      dataIndex: 'campaign_name',
      align: 'center',
    },
    {
      title: '广告主ID',
      dataIndex: 'advertiser_id',
      align: 'center',
    },
    {
      title: '撞线时间',
      dataIndex: 'created_at',
      align: 'center',
    },
    {
      title: '撞线时日预算',
      dataIndex: 'budget',
      align: 'center',
    },
    {
      title: '撞线时花费',
      dataIndex: 'cost',
      align: 'center',
    },
    {
      title: '操作',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' },
      align: 'center',
    },
  ];
  module: any = '';
  @Watch('$route')
  onRouteChange() {
    const { page, pageSize, module } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (module) {
      params.module = module;
      this.module = module;
    }
    this.pagination.current = Number(page);
    this.pagination.pageSize = Number(pageSize);
    this.getList(params);
  }

  refresh() { }

  back() {
    this.$router.push({
      name: 'workbenches.index',
    });
  }

  goToShopDetail(id: string) {
    const routeUrl = this.$router.resolve({
      name: 'main.shop.detail',
      params: {
        id: `${id}`,
      },
    });
    window.open(routeUrl.href, '_blank');
  }
  async getList(params: any) {
    const res = await this.workbenchesService.getMyTodoList(params);
    this.dataSource = res.list;
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }

  mounted() {
    this.onRouteChange();
  }
  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    const query: any = {
      page,
      pageSize,
      module: this.module,
    };
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }
}
